import StorageIcon from '@mui/icons-material/Storage';
import MaterialstorageList from './MaterialstorageList';
import MaterialstorageEdit from './MaterialstorageEdit';
import MaterialstorageCreate from './MaterialstorageCreate';

export default {
    list: MaterialstorageList,
    create: MaterialstorageCreate,
    edit: MaterialstorageEdit,
    icon: StorageIcon,
};
